import type {SchemaPluginOptions} from 'sanity'

// documents
import site from './documents/site'
import page from './documents/page'
import blogPost from './documents/blog.post'
import blogVideo from './documents/blog.video'
import blogCategoryCluster from './documents/blog.category-cluster'
import blogCategory from './documents/blog.category'
import blogTag from './documents/blog.tag'
import navigation from './documents/navigation'
import redirect from './documents/redirect'

// objects
import link from './objects/link'
import linkList from './objects/link.list'
import metadata from './objects/metadata'
import portableTextContent from './portable-text/portable-text-content'
import portableTextVideoContent from './portable-text/portable-text-video-content'
import portableText from './portable-text/portable-text'
import oembed from './portable-text/oembed'
import quote from './portable-text/quote'
import inlineBanner from './portable-text/inline-banner'
import relatedCruises from './portable-text/related-cruises'
import mediaText from './portable-text/media-text'
import downloadFile from './portable-text/download-file'
import buttonLink from './portable-text/button-link'
import fycFilters from './objects/fyc-filters'
import buttonType from './objects/button-type'
import inlineBannerItem from './objects/inline-banner-item'
import postsSlider from './modules/posts-slider'

// modules
import pageTitle from './modules/page-title'
import featuredPosts from './modules/featured-posts'
import inlineSearchSection from './modules/inline-search-section'
import postsByTag from './modules/posts-by-tag'
import postsByCategory from './modules/posts-by-category'
import contentSection from './modules/content-section'
import featuredCruisesSection from './modules/featured-cruises-section'
import videosSlider from './modules/videos-slider'

// references
import author from './documents/blog.author'
import {StructureResolver} from 'sanity/structure'
import * as ctaButtons from './objects/cta-buttons'
import categoriesTaxonomy from './desk-structure/categories-taxonomy'
import postsStructure from './desk-structure/posts-structure'
import tagsStructure from './desk-structure/tags-structure'
import cruiseFilters from './objects/cruise-filters'
import fycYearMonthFilter from './objects/fycYearMonthFilter'
import videosStructure from './desk-structure/videos-structure'

export const schema: SchemaPluginOptions = {
  types: [
    // documents
    site,
    page,
    blogPost,
    blogVideo,
    blogCategoryCluster,
    blogCategory,
    blogTag,
    author,

    navigation,
    redirect,

    // objects
    link,
    linkList,
    metadata,
    portableTextContent,
    portableTextVideoContent,
    portableText,
    oembed,
    quote,
    inlineBanner,
    relatedCruises,
    mediaText,
    downloadFile,
    buttonLink,
    fycFilters,
    ...Object.values(ctaButtons),
    buttonType,
    fycYearMonthFilter,
    cruiseFilters,
    inlineBannerItem,

    // modules
    pageTitle,
    featuredPosts,
    inlineSearchSection,
    featuredCruisesSection,
    postsByTag,
    postsByCategory,
    postsSlider,
    videosSlider,
    contentSection,
  ],

  templates: (templates) =>
    templates.filter(({schemaType}) => !singletonTypes.includes(schemaType)),
}

const singletonTypes = ['site']

export const structure: StructureResolver = (S, context) =>
  S.list()
    .title('Blog')
    .items([
      S.documentTypeListItem('page').title('Pages'),
      S.divider({id: 'articles', title: 'Articles', type: 'divider'}),
      postsStructure(S, context),
      videosStructure(S, context),
      categoriesTaxonomy(S, context),
      tagsStructure(S, context),
      S.documentTypeListItem('blog.author').title('Authors'),

      S.divider({id: 'configurations', title: 'Configurations', type: 'divider'}),
      S.documentTypeListItem('navigation'),
      S.documentTypeListItem('redirect'),
      S.listItem()
        .id('site')
        .schemaType('site')
        .title('Site Settings')
        .child(S.editor().id('site').schemaType('site').documentId('site')),
    ])
//.items([...S.documentTypeListItems()])
